import React, { memo } from 'react'

export default memo(() => (
    <svg
        width="400"
        height="400"
        viewBox="0 0 400 400"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M94.9798 85.22H178.02V250.17H68.0498V112.16L94.9798 85.22Z"
            stroke="#737373"
            stroke-width="4.38"
        />
        <path
            d="M94.9898 112.16H68.0498L94.9898 85.22V112.16Z"
            stroke="#737373"
            stroke-width="4.38"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M80.96 130.09H111.49" stroke="#13B5EA" stroke-width="4.38" />
        <path d="M80.4004 143.35H152.9" stroke="#13B5EA" stroke-width="4.38" />
        <path d="M80.4004 156.61H152.9" stroke="#13B5EA" stroke-width="4.38" />
        <path d="M80.4004 169.86H152.9" stroke="#13B5EA" stroke-width="4.38" />
        <path d="M80.4004 183.12H127.32" stroke="#13B5EA" stroke-width="4.38" />
        <path
            d="M314.55 140.12H231.51V305.07H341.48V167.05L314.55 140.12Z"
            stroke="#737373"
            stroke-width="4.38"
        />
        <path
            d="M314.54 167.05H341.48L314.54 140.11V167.05Z"
            stroke="#737373"
            stroke-width="4.38"
            stroke-linejoin="round"
        />
        <path d="M245.58 184.99H323.23" stroke="#B7C747" stroke-width="4.38" />
        <path d="M244.97 198.24H310.84" stroke="#B7C747" stroke-width="4.38" />
        <path d="M244.97 211.5H325.43" stroke="#B7C747" stroke-width="4.38" />
        <path d="M244.97 224.76H325.43" stroke="#B7C747" stroke-width="4.38" />
        <path d="M244.97 238.02H297.04" stroke="#B7C747" stroke-width="4.38" />
        <path
            d="M364.09 303.97V308.73H360.28V303.97H364.09ZM364.09 313.48V318.24H360.28V313.48H364.09ZM364.09 322.99V328.7H360.28V322.99H364.09ZM356.48 324.89V328.7H351.72V324.89H356.48ZM346.97 324.89V328.7H342.21V324.89H346.97Z"
            fill="#A7ACA8"
        />
        <path
            d="M88.9297 286.62H83.2097V282.04H88.9297V286.62ZM77.4897 286.62H71.7697V282.04H77.4897V286.62ZM66.0497 286.62H59.4697L58.7997 285.96L60.4097 284.28V282.05H66.0497V286.63V286.62ZM54.6897 281.85L50.6397 277.81L53.8797 274.57L57.9297 278.61L54.6897 281.85ZM46.5997 273.76L42.5597 269.72L45.7997 266.48L49.8397 270.52L46.5997 273.76ZM38.5097 265.67L35.9997 263.15V259.09H40.5697V261.25L41.7497 262.43L38.5097 265.67ZM35.9797 253.38V247.66H40.5497V253.38H35.9797ZM35.9697 241.94V236.22H40.5397V241.94H35.9697ZM35.9597 230.5V224.78H40.5297V230.5H35.9597ZM35.9497 219.06V213.34H40.5197V219.06H35.9497ZM35.9397 207.62V201.9H40.5097V207.62H35.9397ZM35.9297 196.18V190.46H40.4997V196.18H35.9297Z"
            fill="#A7ACA8"
        />
        <path
            d="M122.49 322.29H181.42V309.06H122.49"
            stroke="#006BB0"
            stroke-width="4.38"
        />
        <path
            d="M122.49 306.96H65.3596C61.3796 306.96 58.1396 310.19 58.1396 314.18V317.19C58.1396 321.17 61.3696 324.41 65.3596 324.41H122.49V306.97V306.96Z"
            stroke="#006BB0"
            stroke-width="4.38"
        />
        <path
            d="M71.6104 306.96V325.57C71.6104 329.56 74.8404 332.79 78.8204 332.79H112.86"
            stroke="#006BB0"
            stroke-width="4.38"
        />
        <path
            d="M204.48 315.49C200.01 315.49 192.69 317.78 191.92 320.79H182.97"
            stroke="#006BB0"
            stroke-width="4.38"
        />
        <path
            d="M204.48 315.49C200.01 315.49 192.69 313.2 191.92 310.19H182.97"
            stroke="#006BB0"
            stroke-width="4.38"
        />
        <path
            d="M245.58 123.01H215.95V171.66"
            stroke="#A4E3ED"
            stroke-width="4.38"
        />
        <path
            d="M329.03 88.71L332.57 85.11L336.17 88.71L332.57 92.31L329.03 88.71ZM321.84 81.57L325.44 77.97L329.04 81.57L325.44 85.17L321.84 81.57ZM314.7 74.43L318.3 70.83L321.85 74.43L318.3 77.98L314.7 74.43Z"
            fill="#33B55B"
        />
        <path
            d="M314.69 88.76L318.29 85.16L321.84 88.76L318.29 92.36L314.69 88.76ZM321.83 81.62L325.43 78.02L329.03 81.62L325.43 85.17L321.83 81.62ZM329.02 74.43L332.56 70.83L336.16 74.43L332.56 78.03L329.02 74.43Z"
            fill="#33B55B"
        />
    </svg>
))
